<template>
    <div class="page">
        <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
        >
            <van-cell v-for="item in activityList" :key="item" @click="gotoDetail(item.id)">
                <van-row class="activity-item" type="flex" justify="left">
                    <van-col>
                        <img :src="item.pictureUrl" class="activity-cover"/>
                    </van-col>
                    <van-col>
                        <van-row class="activity-title">{{item.title}}</van-row>
                        <van-row class="activity-pos">{{item.address}}</van-row>
                        <van-row class="activity-time">举办时间{{item.startTime}}-{{item.endTime}}</van-row>
                    </van-col>
                </van-row>
            </van-cell>
        </van-list>
    </div>
</template>

<script>
    import {activityList} from '@/api/api'
    import {activityDetail} from '@/api/api'
    import { Toast } from 'vant';
    export default {
        name: "activity-center",
        data(){
            return {
                activityList: [
                    {
                        img:'https://imgdc.wangxiaobao.com/1591803914499@xizang1.jpeg',
                        title:'篮球馆举行篮球比赛，全市皆可报名，冠军奖金高达1万元，欢迎大家踊跃参与',
                        postion:'天府一架起',
                        time:'2020-5-6'
                    },
                    {
                        img:'https://imgdc.wangxiaobao.com/1591803977253@xizang2.jpeg',
                        title:'羽毛球馆来了，试运营期间5遮优惠，欢迎大家积极预约',
                        postion:'天府一架起',
                        time:'2020-5-6'
                    },
                    {
                        img:'https://imgdc.wangxiaobao.com/1591804011401@xizang3.jpeg',
                        title:'乒乓球场地包月卡优惠，月卡200客享受提前预约，8折优惠',
                        postion:'天府一架起',
                        time:'2020-5-6'
                    }
                ],
                loading: false,
                finished: true,

            }
        },
        created(){
            this.getActivityList()
        },
        methods:{
            getActivityList(){
                activityList().then(res=>{
                    if (res.code==0){
                        this.activityList = res.data.list

                    }
                })
            },
            gotoDetail(id){
                this.$router.push({path: '/newsdetail?aid=' + id});
            },
            onLoad(){

            }
        }
    }
</script>

<style scoped>
    .activity-item{
        width: 100%;
        height: 104px;

    }
    .activity-cover{
        width: 104px;
        height: 104px;
        border-radius: 15px;
        margin-right: 12px;
    }
    .activity-title{
        height: 48px;
        font-size:17px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(40,43,49,1);
        line-height:24px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        margin-bottom: 12px;
    }
    .activity-pos{
        font-size:12px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(103,108,117,1);
        line-height:17px;
    }
    .activity-time{
        font-size:12px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(103,108,117,1);
        line-height:17px;
        margin-top: 8px;
    }
</style>